(function($) {
  'use strict';

  /**
   * Медиа-альбом
   * @param {Object} [options] - объект с параметрами
   * @returns {jQuery}
   */
  $.fn.eshopProductGallery = function (options) {
      const defaults = {
          pageSize: 23,
          itemSelector: '.js-eshop-product-gallery-item',
          zoomSelector: '.js-eshop-product-gallery-zoom'
      };
      let settings = $.extend({}, defaults, options);

      let $container = $(this);
      let ajaxUrl = $container.data('ajaxUrl');
      let albumData = [];
      let currentPage = 0;
      const $popupTemplate = $('.js-popup-template');
      let $popup;


      const getFakeData = function () {
        let $items = $container.find(settings.itemSelector);
        return $items.map(function () {
          let $el = $(this);
          return {
            itemUrl: $el.attr('href'),
            itemWidth: $el.find('img').attr('width'),
            itemHeight: $el.find('img').attr('height'),
            previewUrl: $el.attr('href'),
            previewWidth: $el.find('img').attr('width'),
            previewHeight: $el.find('img').attr('height'),
          };
        }).get();
      };

      /**
       * Получение списка элементов альбома
       */
      const getAlbumData = function () {
        $.ajax({
            url: ajaxUrl
        }).done(function (data) {
          // albumData = data; // TODO !!
          albumData = getFakeData();
          // renderItems(albumData);
        }).fail(function (err) {
          console.log('Не удалось получить список элементов альбома');
        });
      };

      /**
       * Рендер элементов альбома из JSON
       * @param {Object[]} data - массив JSON-объектов с элементами альбома
       * @param {Number} [pageNumber] - номер страницы
       */
      const renderItems = function (data, pageNumber) {
        currentPage = typeof pageNumber !== 'undefined' ? pageNumber : 0;

        if (data.length) {
          $container.empty();

          let startItemIndex = currentPage * settings.pageSize;
          let endItemIndex = startItemIndex + settings.pageSize;

          for (let i = startItemIndex; i < Math.min(endItemIndex, data.length); i++) {
            $container.append($('<div>', {
              class: 'media-grid-item',
              append: $('<a>', {
                class: 'js-eshop-product-gallery-item',
                href: data[i].itemUrl,
                attr: {
                  'data-item-index': i
                },
                append: $('<img>', {
                  alt: '',
                  src: data[i].previewUrl,
                  loading: 'lazy',
                  attr: {
                    width: data[i].previewWidth,
                    height: data[i].previewHeight,
                  }
                })
              })
            }));
          }
        }
      };

      /**
       * Update элементов альбома
       * @param {Object[]} data - массив JSON-объектов с элементами альбома
       * @param {Number} [pageNumber] - номер страницы
       */
      const updateItems = function (pageNumber) {
        currentPage = typeof pageNumber !== 'undefined' ? pageNumber : 0;
        let data = $container.find(settings.itemSelector);

        if (data.length) {

          let startItemIndex = currentPage * settings.pageSize;
          let endItemIndex = startItemIndex + settings.pageSize;

          data.each(function(i, el) {
            $(el).attr('data-item-index', i);
          });
        }
      };

      /**
       * Открыть попап из шаблона
       */
      const openPopup = function () {
          $popup = $popupTemplate.clone();
          $popup.appendTo('body');
          $('html').css('overflow', 'hidden');
          $popup.on('click', function (e) {
              let $target = $(e.target);
              if ($target.is($popup) || $target.closest('.js-popup-close').length) {
                  closePopup();
              } else if ($target.closest('.js-popup-prev').length) {
                  prevMedia();
              } else if ($target.closest('.js-popup-next').length) {
                  nextMedia();
              }
          });
          if (typeof $.fn.swipe !== 'undefined') {
              $popup.swipe({
                  swipe: function (event, direction) {
                      switch (direction) {
                          case 'left':
                              nextMedia();
                              break;
                          case 'right':
                              prevMedia();
                              break;
                      }
                  }
              })
          }
      };

      /**
       * Закрыть попап
       */
      const closePopup = function () {
          $popup.remove();
          $('html').css('overflow', '');
      };

      /**
       * Перейти к предыдущему элементу альбома в попапе
       */
      const prevMedia = function () {
          if ($(document).find($popup).length) {
              setPopupContentByItemIndex($popup.data('currentIndex') - 1);
          }
      };

      /**
       * Перейти к следующему элементу альбома в попапе
       */
      const nextMedia = function () {
          if ($(document).find($popup).length) {
              setPopupContentByItemIndex($popup.data('currentIndex') + 1);
          }
      };

      /**
       * Установить контент попапа по индексу элемента альбома
       * @param {Number} index - индекс элемента альбома
       */
      const setPopupContentByItemIndex = function (index) {
          if (albumData.length && $(document).find($popup).length) {
              index = (index + albumData.length) % albumData.length; // зацикливаем список
              let currentItemData = albumData[index];
              console.log(albumData);
              $popup.data('currentIndex', index);
              if ($popup.find('img').length) {
                  $popup.find('img').remove();
              }
              $popup
                  .find('.js-popup-content')
                  .css({
                      width: '',
                      height: ''
                  })
                  .append($('<img>', {
                      src: currentItemData.itemUrl,
                      alt: '',
                      loading: 'lazy',
                      attr: {
                          width: currentItemData.itemWidth,
                          height: currentItemData.itemHeight
                      },
                      on: {
                          load: function () {
                              let maxWidth = $popup.width();
                              let maxHeight = $popup.height();
                              let xRatio = currentItemData.itemWidth / maxWidth;
                              let yRatio = currentItemData.itemHeight / maxHeight;
                              let maxRatio = Math.max(xRatio, yRatio);

                              if (maxRatio > 1) {
                                  $popup.find('.js-popup-content').css({
                                      width: currentItemData.itemWidth / maxRatio,
                                      height: currentItemData.itemHeight / maxRatio
                                  });
                              }
                          }
                      }
                  }))
                  .find('.js-popup-item-count')
                  .text((index + 1) + '/' + albumData.length);
          }
      };

      const init = function () {
        getAlbumData();
        updateItems();

        // клик по элементу альбома - открытие попапа
        $(document).on('click', settings.itemSelector, function (e) {
          openPopup();
          setPopupContentByItemIndex($(this).data('item-index'));

          return false; // запрещаем переход по ссылке при открытии попапа
        });

        // клик по элементу альбома - открытие попапа
        $(document).on('click', settings.zoomSelector, function (e) {
          openPopup();
          setPopupContentByItemIndex(0);

          return false; // запрещаем переход по ссылке при открытии попапа
        });

        // управление с клавиатуры
        $(document).on('keydown', function(e) {
          if ($(document).find($popup).length) {
              switch (e.key) {
                  case 'ArrowLeft':
                      prevMedia();
                      break;

                  case 'ArrowRight':
                      nextMedia();
                      break;

                  case ' ':
                      nextMedia();
                      break;

                  case 'Escape':
                      closePopup();
                      break;
              }
          }
        });
      };

      init();

      return this;
  };
})(jQuery);
